import { Notify } from 'quasar';

export function notifyError(
  errorMessage: string | null = null,
  options: { html?: boolean } = {}
) {
  const notifyMessage =
    errorMessage ||
    'Unfortunately we experienced a technical error, please try again in a short while.';

  Notify.create({
    color: 'red-9',
    textColor: 'white',
    message: notifyMessage,
    html: options.html ?? false,
  });
}
